export default {
    intro: '看释义，选出正确的单词吧！',
    th: { order: '编号', meaning: '题目', answer: '正确答案', wrong: '错误答案', wrongChoices: '错误选项', correctRate: '正确率' },
    manySelectedWrongAnswer: '被选最多的错误答案',
};
